import { DispatchState } from './../dispatch-state/dispatch-state';
import { Client } from "../client/client";
import { Machine } from "../machine/machine";
import { User } from "../user/user";
import { FixCat } from '../fixcat/fixcat';
import { DispatchItem } from '../dispatchitem/dispatchitem';

export class DispatchOrder
{
id:  number; 
client: Client; 
user : User;
machines:  Machine[]; 
date: Date; 
details : String; 
dispatchstate : DispatchState;
fixcats : FixCat[]; 
orderitems : DispatchItem[];
note: string;
}

export class DispatchOrderCreate
{
    id: number;
details : String; 
client : number ;
user : number; 
machines : number[];
date: Date;
dispatchstate: number; 
fixcats : number []; 
orderitems : number [];
note: string;
}